import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const PartialCheckmarkIcon: React.FC<Props> = ({
  color,
  ...svgProps
}) => {
  return (
    <SVG
      viewBox="0 0 12 10"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 10)}
      strokeWidth="3"
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="0 0 .1 4"
    >
      <path d="m1.5 5 3.1 3L10 1.5" />
    </SVG>
  );
};
